// do not change value-case, since they are used as query-parameter value, where "-" have problems
export enum PartFilter {
  AVAILABLE_FOR_CALCULATION = 'available-for-calculation',
}
